module.exports = __webpack_public_path__ + "static/img/2.6.2369449.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/hk/upload/picture/2.6.jpg
// module id = Rq6h
// module chunks = 7